<template>
  <div>
    <div class="d-flex" v-if="isLoading">
      <div style="width: 6%">
        <b-skeleton-icon icon="question" :icon-props="{ fontScale: 3 }"></b-skeleton-icon>
      </div>
      <div class="mr-2" style="width: 82%">
        <b-skeleton width="25%"></b-skeleton>
        <b-skeleton width="95%"></b-skeleton>
      </div>
      <div>
        <b-skeleton type="button" width="100px"></b-skeleton>
      </div>
    </div>
    <div v-else class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center mr-2">
        <md-icon class="mr-2 setup-guide-icon">{{ rowIcon }}</md-icon>
        <div>
          <strong>{{ title }}</strong>
          <p class="mb-0 checklist-description">
            {{ description }}
          </p>
          <span style="font-size: 12px;" v-if="abbr === 'add_certifications'">
            No certifications?
            <a
              class="ml-1 mt-2 text-secondary"
              style="font-size: 12px;"
              :href="`${careCampusUrl}/${get(selectedUni, 'slug')}/programs`"
              target="_blank"
              >Learn More</a
            >
          </span>
        </div>
      </div>
      <b-btn variant="primary" class="setup-guide-btn btn-normal" disabled v-if="isLoading"
        ><i class="fas fa-circle-notch fa-spin"></i
      ></b-btn>
      <b-btn
        variant="success"
        class="setup-guide-btn btn-normal"
        :href="
          abbr === 'career_assessment'
            ? `${careCampusUrl}/${get(selectedUni, 'slug')}/career-assessment?uuid=${get(getLoggedInUser, 'user_uuid')}`
            : null
        "
        :to="getRouteTarget()"
        :target="abbr === 'career_assessment' ? '_blank' : ''"
        v-else-if="!!get(status, `${abbr}.earned`)"
      >
        <i class="material-icons icon-16pt">stars</i>
        <span class="ml-1">
          {{
            get(status, `${abbr}.total`)
              ? `${get(status, `${abbr}.earned`)} / ${get(status, `${abbr}.total`)}`
              : get(status, `${abbr}.earned`)
          }}
        </span>
      </b-btn>
      <router-link
        v-else
        class="btn btn-primary setup-guide-btn btn-normal"
        :href="
          abbr === 'career_assessment'
            ? `${careCampusUrl}/${get(selectedUni, 'slug')}/career-assessment?uuid=${get(getLoggedInUser, 'user_uuid')}`
            : null
        "
        :to="getRouteTarget()"
        :target="abbr === 'career_assessment' ? '_blank' : ''"
        >{{ btnText }}</router-link
      >
    </div>
  </div>
</template>

<script>
// One icon per checklist task. Every resume task shares the resume icon.
const TASK_ICONS = {
  career_assessment: 'psychology',
  education_resume: 'description',
  work_experience_resume: 'description',
  volunteer_experience_resume: 'description',
  skills_resume: 'description',
  latest_title_location_resume: 'description',
  practice_skill_simulations: 'record_voice_over',
  add_certifications: 'workspace_premium',
  add_new_courses: 'menu_book',
  add_letters_of_recommendation: 'drafts',
  add_activities: 'interests',
  add_admissions_assessments: 'quiz',
  add_licenses: 'badge',
  add_degrees: 'history_edu',
  add_prep_courses: 'local_library',
};

import { get } from 'lodash';
import { mapGetters } from 'vuex';
import { getClickableLink } from '@/common/utils';

export default {
  name: 'CareCampusChecklistRow',
  props: {
    icon: { type: String, default: () => '' },
    title: { type: String, default: () => '' },
    description: { type: String, default: () => '' },
    redirectTo: { type: String, default: () => '' },
    isLoading: { type: Boolean, default: () => true },
    status: { type: Object, default: () => ({}) },
    btnText: { type: String, default: () => 'Explore' },
    abbr: { type: String, default: () => '' },
    selectedUni: { type: Object, default: () => {} },
    redirectQuery: { type: Object, default: () => null },
  },

  data() {
    return {
      careCampusUrl: process.env.VUE_APP_UNI_SPONSORED_URL,
    };
  },

  computed: {
    rowIcon() {
      return TASK_ICONS[this.abbr] || this.icon || 'task_alt';
    },
    ...mapGetters('auth', ['getLoggedInUser']),
  },

  methods: {
    get,

    isProgramScopedAction() {
      return [
        'add_certifications',
        'add_new_courses',
        'add_letters_of_recommendation',
        'add_activities',
        'add_admissions_assessments',
        'add_admission_assessments',
        'add_licenses',
        'add_degrees',
        'add_prep_courses',
      ].includes(this.abbr);
    },

    getRouteTarget() {
      const baseQuery = {
        ...(this.redirectQuery || {}),
        ...(this.abbr === 'practice_skill_simulations' && { uniId: get(this.selectedUni, 'id') }),
      };

      const query = { ...baseQuery };

      if (!this.isProgramScopedAction() && query.program_id) {
        delete query.program_id;
      }

      return {
        name: this.redirectTo,
        ...(Object.keys(query).length && { query }),
      };
    },

    getPageLink(url) {
      const cUrl = getClickableLink(url);
      return cUrl.endsWith('/') ? cUrl : `${cUrl}/`;
    },
  },
};
</script>

<style>
.checklist-description {
  color: #525f7f;
}
</style>
